module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesElegant@2x.392d093.webp";